import React, { useEffect, useState } from 'react';
import { books_category } from '../ProData';
import {Helmet} from 'react-helmet-async';

export default function BookCategories() {
  const [booksCategory, setBooksCategory] = useState([]);

  useEffect(() => {
    const tempBooks = books_category.filter((item) => item.categoryDisplay === "Yes");
    setBooksCategory(tempBooks);
  }, []);

  // Add modern background and responsive card grid
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .bookcat-bg {
        min-height: 100vh;
        background: linear-gradient(135deg, #f8fafc 0%, #e0f7fa 100%);
        background-attachment: fixed;
        font-family: Inter, Segoe UI, Arial, sans-serif;
        padding: 0 0 40px 0;
      }
      .bookcat-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 12px;
      }
      .bookcat-heading {
        text-align: center;
        margin-bottom: 2.5rem;
      }
      .bookcat-heading h2 {
        color: #0bb6d7;
        font-weight: 700;
        font-size: 2.1rem;
        margin-bottom: 0.5rem;
      }
      .bookcat-heading p {
        color: #333;
        font-size: 1.08rem;
        margin-bottom: 0;
      }
      .bookcat-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 28px;
      }
      .bookcat-card {
        background: linear-gradient(135deg, #f8fafc 60%, #e0f7fa 100%);
        border-radius: 18px;
        box-shadow: 0 2px 16px #0bb6d71a;
        padding: 24px 18px 18px 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: box-shadow 0.2s, transform 0.2s;
        width: 270px;
        height: 340px;
        min-width: 0;
        min-height: 0;
        max-width: 100%;
        box-sizing: border-box;
        cursor: pointer;
      }
      .bookcat-card:hover {
        box-shadow: 0 6px 24px #0bb6d744;
        transform: translateY(-4px) scale(1.025);
      }
      .bookcat-img {
        width: 80px;
        height: 80px;
        object-fit: contain;
        margin-bottom: 18px;
        border-radius: 12px;
        background: #f8fafc;
        box-shadow: 0 1px 6px #0bb6d71a;
      }
      .bookcat-title {
        color: #063547;
        font-size: 1.13rem;
        font-weight: 600;
        margin-bottom: 0.5rem;
        text-align: center;
      }
      .bookcat-desc {
        color: #444;
        font-size: 0.98rem;
        text-align: center;
      }
      @media (max-width: 900px) {
        .bookcat-card {
          width: 100%;
          height: 260px;
          padding: 16px 8px;
        }
      }
      @media (max-width: 600px) {
        .bookcat-heading h2 { font-size: 1.3rem; }
        .bookcat-card {
          width: 100%;
          height: 180px;
          padding: 12px 4px;
        }
        .bookcat-img { width: 60px; height: 60px; }
        .bookcat-title { font-size: 1rem; }
        .bookcat-desc { font-size: 0.93rem; }
      }
    `;
    style.setAttribute('data-bookcat', 'true');
    if (!document.head.querySelector('style[data-bookcat]')) {
      document.head.appendChild(style);
    }
    return () => {
      if (document.head.querySelector('style[data-bookcat]')) {
        document.head.removeChild(style);
      }
    };
  }, []);

  return (
    <div className="bookcat-bg">
      <Helmet>
        <title>Book Categories - Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
        <meta name="description" content="Book Categories - Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
        <meta name="keywords" content="Book Categories - Library - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
      </Helmet>
      <div className="bookcat-container">
        <div className="bookcat-heading">
          <h2>Books Categories</h2>
          <p>Our library provides a wide range of reading materials, with 65 distinct book categories and over 2,000 specific classifications.</p>
        </div>
        <div className="bookcat-grid">
          {booksCategory.map((item, index) => (
            <div className="bookcat-card" key={index}>
              <img src={item.categoryImage} alt={item.name} className="bookcat-img" />
              <div className="bookcat-title">{item.name}</div>
              <div className="bookcat-desc">{item.categoryDesc}</div>
            </div>
          ))}
          {/*<div className="col-sm-6 col-md-4 ">
            <div className="box ">
              <div className="img-box">
                <img src="images/cat2.png" alt="" />
              </div>
              <div className="detail-box">
                <h5>
                  Science
                </h5>
                <p>
                  fact that a reader will be distracted by the readable content of a page when looking at its layout.
                  The
                  point of using
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 ">
            <div className="box ">
              <div className="img-box">
                <img src="images/cat3.png" alt="" />
              </div>
              <div className="detail-box">
                <h5>
                  History
                </h5>
                <p>
                  fact that a reader will be distracted by the readable content of a page when looking at its layout.
                  The
                  point of using
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 ">
            <div className="box ">
              <div className="img-box">
                <img src="images/cat4.png" alt="" />
              </div>
              <div className="detail-box">
                <h5>
                  Biography
                </h5>
                <p>
                  fact that a reader will be distracted by the readable content of a page when looking at its layout.
                  The
                  point of using
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 ">
            <div className="box ">
              <div className="img-box">
                <img src="images/cat5.png" alt="" />
              </div>
              <div className="detail-box">
                <h5>
                  Adventure
                </h5>
                <p>
                  fact that a reader will be distracted by the readable content of a page when looking at its layout.
                  The
                  point of using
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4 ">
            <div className="box ">
              <div className="img-box">
                <img src="images/cat6.png" alt="" />
              </div>
              <div className="detail-box">
                <h5>
                  Fantasy
                </h5>
                <p>
                  fact that a reader will be distracted by the readable content of a page when looking at its layout.
                  The
                  point of using
                </p>
              </div>
            </div>
          </div>*/}
        </div>
      </div>
    </div>
  );
        // ...existing code...
  
}
